import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import imgGroup from "../../assets/img_group3.png";
import ScrollOut from "scroll-out";

const Organization = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="권역도" eng="GROUP"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="group-info-wrap" data-scroll>
                        <img src={imgGroup} alt="이미지" className="img_groups" />
                    </div>
                </div>
            </main>
        </>
    );
};

export default Organization;
